import { render, staticRenderFns } from "./ChannelHistory.vue?vue&type=template&id=c17dad02&scoped=true&"
import script from "./ChannelHistory.vue?vue&type=script&lang=js&"
export * from "./ChannelHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChannelHistory.vue?vue&type=style&index=0&id=c17dad02&scoped=true&lang=css&"
import style1 from "./ChannelHistory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17dad02",
  null
  
)

export default component.exports